import { AccessCodes } from '@pm2/api';

function getChaptersInCourse(course) {
  if (!course) {
    return [];
  }
  if (course.type !== "Course") {
    throw new Error(`getChaptersInCourse(): Invariant, expected provided descriptor to be of type 'Course'`);
  }
  return recursivelyExtractChapters(course);
}
function recursivelyExtractChapters(descriptor) {
  const chapters = [];
  for (const child of descriptor.children ?? []) {
    switch (child.type) {
      case "Chapter":
      case "Page":
        if (child.accessCode === AccessCodes.ALLOWED && !child.hidden) {
          chapters.push(child);
        }
        break;
      case "ChapterGroup":
        chapters.push(...recursivelyExtractChapters(child));
        break;
    }
  }
  return chapters;
}

export { getChaptersInCourse };
//# sourceMappingURL=util.get-chapters-in-course.js.map
